import Toastify from "../../components/alerts/Toastify";
import LocalStorageService from "../localStorage/localStorageService";
import {toast} from "react-toastify";

export default class ResponseProcessorService {

    static processTramiteMetadata(response) {
        let fecha = new Date(response.data.date).toLocaleString("en-GB", { hour12: false });
        return {
            estado: response.data.stage,
            response: response.data.data,
            actualizacion: fecha
        };
    }

    static processError(error) {
        if(error.response.status === 401 || error.response.status === 403) {
            LocalStorageService.logout();
            window.location.assign("/admin/inactive");
        }
        Toastify.error(toast, error.response.data.message);
    }
}
